import React, { useEffect, useState } from "react";
import db from "./Firebase";

function UpdateTxnId() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    // 🔍 Search
    const [searchQuery, setSearchQuery] = useState("");

    // 🔁 Modal + Update
    const [showModal, setShowModal] = useState(false);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [txnIdInput, setTxnIdInput] = useState("");
    const [updating, setUpdating] = useState(false);

    // 🔹 Fetch ALL records
    useEffect(() => {
        const unsubscribe = db
            .collection("nv_loan")
            .orderBy("created_date", "desc")
            .onSnapshot((snapshot) => {
                const records = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }));
                setData(records);
                setLoading(false);
            });

        return () => unsubscribe();
    }, []);

    // 🔍 Filter by username
    const filteredData = data.filter(({ data }) =>
        data.username
            ?.toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
    );

    // 🔹 Open modal
    const openModal = (docId, currentTxnId) => {
        setSelectedDocId(docId);
        setTxnIdInput(currentTxnId || "");
        setShowModal(true);
    };

    // 🔹 Update txn_id
    const updateTxnId = async () => {
        if (!txnIdInput.trim()) {
            alert("Please enter Transaction ID");
            return;
        }

        try {
            setUpdating(true);
            await db.collection("nv_loan").doc(selectedDocId).update({
                txn_id: txnIdInput.trim(),
            });

            setShowModal(false);
            setTxnIdInput("");
            setSelectedDocId(null);
        } catch (err) {
            console.error(err);
            alert("Failed to update Transaction ID");
        } finally {
            setUpdating(false);
        }
    };

    if (loading) {
        return <p className="p-3">Loading...</p>;
    }

    return (
        <div className="p-3">
            <h5 className="mb-3">Update Transaction IDs</h5>

            {/* 🔍 Search Box */}
            <input
                type="text"
                className="form-control form-control-sm mb-3"
                placeholder="Search by Username"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
            />

            <div className="table-responsive">
                <table className="table table-bordered table-hover">
                    <thead className="thead-dark">
                        <tr>
                            <th>Sr. No</th>
                            <th>Username</th>
                            <th>Transaction ID</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length === 0 && (
                            <tr>
                                <td colSpan="4" className="text-center">
                                    No data found
                                </td>
                            </tr>
                        )}

                        {filteredData.map(({ id, data }, index) => (
                            <tr key={id}>
                                <td>{index + 1}</td>
                                <td>{data.username}</td>
                                <td>
                                    {data.txn_id ? (
                                        data.txn_id
                                    ) : (
                                        <span className="text-muted">Not Found</span>
                                    )}
                                </td>
                                <td>
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() =>
                                            openModal(id, data.txn_id)
                                        }
                                    >
                                        Update
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* 🔹 Modal */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.35)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "20px",
                            borderRadius: "8px",
                            width: "320px",
                            boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
                        }}
                    >
                        <h6 className="mb-3">Update Transaction ID</h6>

                        <input
                            type="text"
                            className="form-control mb-3"
                            placeholder="Enter Transaction ID"
                            value={txnIdInput}
                            onChange={(e) => setTxnIdInput(e.target.value)}
                        />

                        <div className="d-flex justify-content-end gap-2">
                            <button
                                className="btn btn-light btn-sm"
                                onClick={() => setShowModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-success btn-sm"
                                onClick={updateTxnId}
                                disabled={updating}
                            >
                                {updating ? "Saving..." : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default UpdateTxnId;
